import React, { useEffect, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUserAccount } from '../../store/actions/user';
import { getPriorityMessages, openFirstPriorityMessage } from '../../store/actions/messages';
import HeaderTop from './Top/Top';
import HeaderBottom from './Bottom/Bottom';

const Header = () => {
    const dispatch = useDispatch();
    const isFetching = useSelector(state => state.settings.account.requesting);
    const cashierInfo = useSelector(state => state.settings.account.data);

    useEffect(() => {
        const getUserDetails = async () => {
            await dispatch(getUserAccount());
            handlePriorityMessages();
        };

        getUserDetails();
    }, [dispatch]);

    const handlePriorityMessages = async () => {
        const messages = await dispatch(getPriorityMessages());
        dispatch(openFirstPriorityMessage(messages));
    };

    return (
        <>
            <HeaderTop fetchingAccount={isFetching} cashier={cashierInfo} />
            <HeaderBottom />
        </>
    );
};

export default memo(Header);
